export default __webpack_public_path__ + "static/media/advanced_1.02acd67e.svg";